module.exports = __webpack_public_path__ + "img/HJ.e3162711.jpg";